import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Slider from 'react-slick';
import { AsyncImage } from 'loadable-image';
import './ProjectGallery.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import projectGalleryData from '../../data/projectgallery.json';

const ProjectGallery = ({ isAlbanian, projectId }) => {
  const sliderRef = useRef(null);
  const modalSliderRef = useRef(null);
  const navigate = useNavigate();
  const [galleryImages, setGalleryImages] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [projects, setProjects] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(1);

  useEffect(() => {
    if (!projectId) return;

    // Filtrimi i imazheve vetëm për këtë projectId
    const filteredImages = projectGalleryData.filter(
      (img) => String(img.project_id) === String(projectId)
    );

    setGalleryImages(filteredImages);
  }, [projectId]);

  useEffect(() => {
    const handleResize = () => {
      setSlidesToShow(window.innerWidth < 576 ? 1 : 2);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowLeft') {
        if (isModalOpen) {
          modalSliderRef.current?.slickPrev();
        } else {
          sliderRef.current?.slickPrev();
        }
      } else if (event.key === 'ArrowRight') {
        if (isModalOpen) {
          modalSliderRef.current?.slickNext();
        } else {
          sliderRef.current?.slickNext();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isModalOpen]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    centerMode: true, 
    centerPadding: "0px", 
    arrows: false,
    swipe: true,
    touchThreshold: 10,
    draggable: true,
    adaptiveHeight: true,
  };

  const modalSettings = {
    ...settings,
    slidesToShow: 1,
    initialSlide: currentSlide,
    beforeChange: (_, next) => setCurrentSlide(next),
  };

  const openModal = (index) => {
    setCurrentSlide(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleNavigate = (projectId) => {
    console.log("Navigating to project ID:", projectId);
    if (projectId) {
      // This forces a full page reload
      window.location.href = `/vilalproject/${projectId}`;
    } else {
      console.error("Project ID is null or undefined");
    }
  };
  
  

  return (
    <div>
      <div className="projectgallery-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>

          {galleryImages.length > 0 && galleryImages[0].prev && (
      <button 
        className="prev-button-outside" 
        onClick={() => handleNavigate(galleryImages[0].prev)}
      >
       <img src="/prev.png" alt="Prev" className="prevPro-btn-img"/>
      </button>
    )}
    {galleryImages.length > 0 && galleryImages[0].next && (
      <button 
        className="nextBottom-button-outside" 
        onClick={() => handleNavigate(galleryImages[0].next)}
      >
       <img src="/next.png" alt="Next" className="nextProBottom-btn-img"/>
      </button>
    )}
        
          <div className="projectgallery-paragraph">
          <div className='things-above-image'>
          <div className="projectgallery-title">{isAlbanian ? 'GALERIA' : 'GALLERY'}</div>
          <div className="top-right-buttons">
            <button className="circle-button" onClick={() => sliderRef.current.slickPrev()}>
              <img src="/b.png" alt="close" className="xCircle-btn-img"/>
            </button>
            <button className="circle-button" onClick={() => sliderRef.current.slickNext()}>
              <img src="/n.png" alt="close" className="xCircle-btn-img"/>
            </button>
          </div>
          </div>
            <Slider ref={sliderRef} {...settings}>
              {galleryImages.map((image, index) => (
                <div key={image.gallery_image_id} className="carousel-slide">
                  <div className="carousel-image-container">
                    <AsyncImage
                      src={image.gallery_image_url}
                      alt={`Project ${image.gallery_image_id}`}
                      onClick={() => openModal(index)}
                      className="carousel-image"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-close-position">
            <button className="modal-close-button" onClick={closeModal}>
              <img src="/x.png" alt="close" className="xClose-btn-img"/>
            </button>
            </div>
            <div className="modal-navigation">
              <button className="modal-nav-button left" onClick={() => modalSliderRef.current.slickPrev()}>
              <img src="/b.png" alt="close" className="xClose-btn-img"/>
              </button>
              <button className="modal-nav-button right" onClick={() => modalSliderRef.current.slickNext()}>
                <img src="/n.png" alt="close" className="xClose-btn-img"/>
              </button>
            </div>
            <Slider ref={modalSliderRef} {...modalSettings}>
              {galleryImages.map((image) => (
                <div key={image.gallery_image_id} className="modal-slide">
                  <img
                    src={image.gallery_image_url}
                    alt={`Gallery image ${image.gallery_image_id}`}
                    className="modal-image"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectGallery;